import React from "react";
function About() {

  return (
    <>
      <div className="Home_Div d-flex flex-wrap p-4 justify-content-around align-items-center">
        <div className="Intro">
          <h1>Student</h1>
          <p>
            I am currently Studying at Vellore Institute of Technology I have a
            GPA of 9.64 and I like engineering very much, I have completed Some
            of the core courses in my college such as DBMS,OS,Machine Learning
            Deep Learning and DSA.
          </p>
        </div>
        <div className="Intro">
          <h1>Developer</h1>
          <p>
            I have used various technologies and created various projects whose
            link is posted in my github, I am skillfull in
            HTML,CSS,JAVASCRIPT,REACT,MONGODB , EXPRESS.I have created various
            project using these technologies which are posted in my github
            account you can access it using my github account
          </p>
        </div>
        <div className="Intro">
          <h1>Hobbies</h1>
          <p>My life is an intricate tapestry woven with the threads of music, movies, games, and books. Music's melodies soothe my soul, while movies offer portals to diverse realms. Gaming challenges my skills, connecting me with a global community, and books provide endless adventures within their pages. These passions enrich my existence, shaping my identity with each note, frame, click, and word</p>
        </div>
        <div className="Intro">
          <h1>Wanderlust</h1>
          <p>A relentless wanderlust, I find my true essence in the vast expanse of the world. Each destination is a chapter in my life, brimming with diverse cultures, flavors, and experiences. With a heart full of curiosity, I explore uncharted territories, collecting memories like precious treasures, embracing the beauty of the unknown.</p>
        </div>
        <div className="Intro">
          <h1>Hobbies</h1>
          <p>My life is an intricate tapestry woven with the threads of music, movies, games, and books. Music's melodies soothe my soul, while movies offer portals to diverse realms. Gaming challenges my skills, connecting me with a global community, and books provide endless adventures within their pages. These passions enrich my existence, shaping my identity with each note, frame, click, and word</p>
        </div>
        <div className="Intro">
          <h1>Wanderlust</h1>
          <p>A relentless wanderlust, I find my true essence in the vast expanse of the world. Each destination is a chapter in my life, brimming with diverse cultures, flavors, and experiences. With a heart full of curiosity, I explore uncharted territories, collecting memories like precious treasures, embracing the beauty of the unknown.</p>
        </div>
        <div className="Intro">
          <h1>Developer</h1>
          <p>
            I have used various technologies and created various projects whose
            link is posted in my github, I am skillfull in
            HTML,CSS,JAVASCRIPT,REACT,MONGODB , EXPRESS.I have created various
            project using these technologies which are posted in my github
            account you can access it using my github account
          </p>
        </div>
      </div>
    </>
  );
}
export default About;
